import { ClaimModel } from "./claim.model";

export class AuthModel {
  accessToken: string;
  refreshToken: string;
  expiresIn: Date;
  claim: ClaimModel;
  setAuth(auth: AuthModel) {
    this.accessToken = auth.accessToken;
    this.refreshToken = auth.refreshToken;
    this.expiresIn = auth.expiresIn;
    this.claim = auth.claim;
  }
}
